import { apiClient } from './api'; // Use the named export for the configured axios instance

// Remove the leading '/api' as it's already in the apiClient baseURL
const API_URL = '/inventory'; 

// Fetch all inventory items
export const getInventoryItems = () => {
    return apiClient.get(API_URL); // Now calls /api/inventory
};

// Fetch a single inventory item by ID
export const getInventoryItem = (id) => {
    return apiClient.get(`${API_URL}/${id}`); // Now calls /api/inventory/:id
};

// Create a new inventory item (handles FormData for image upload)
export const createInventoryItem = (itemData) => {
    const formData = new FormData();
    Object.keys(itemData).forEach(key => {
        if (key === 'image' && itemData[key]) {
            formData.append(key, itemData[key]);
        } else if (itemData[key] !== null && itemData[key] !== undefined) {
            formData.append(key, itemData[key]);
        }
    });
    return apiClient.post(API_URL, formData, { // Now posts to /api/inventory
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// Update an inventory item by ID (handles FormData for image upload)
export const updateInventoryItem = (id, itemData) => {
    const formData = new FormData();
     Object.keys(itemData).forEach(key => {
        if (key === 'image' && itemData[key] instanceof File) {
            formData.append(key, itemData[key]);
        } else if (key === 'removeImage') {
             formData.append(key, itemData[key]);
        } else if (itemData[key] !== null && itemData[key] !== undefined && key !== 'image') {
            formData.append(key, itemData[key]);
        }
    });
    return apiClient.put(`${API_URL}/${id}`, formData, { // Now puts to /api/inventory/:id
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// Delete an inventory item by ID
export const deleteInventoryItem = (id) => {
    return apiClient.delete(`${API_URL}/${id}`); // Now deletes /api/inventory/:id
};
